import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

export default function SubscriptionColumnView() {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      {/* <Column style={{marginRight: '28px', marginLeft: '28px'}}>번호</Column> */}
      <Column color={theme.text} style={{marginRight: '218px', marginLeft: '28px'}}>{t('memberDetail.colMembership')}</Column>
      <Column color={theme.text} style={{marginRight: '62px'}}>{t('memberDetail.colStartDate')}</Column>
      <Column color={theme.text} style={{marginRight: '62px'}}>{t('memberDetail.colEndDate')}</Column>
      <Column color={theme.text} style={{marginRight: '118px'}}>{t('memberDetail.colPaymentAmount')}</Column>
      <Column color={theme.text} style={{marginRight: '54px'}}>{t('memberDetail.colSubscriptionStatus')}</Column>
      <Column color={theme.text} style={{marginRight: '28px'}}>{t('memberDetail.colPaymentCount')}</Column>
      {/* <Column >상태</Column> */}
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 1020px;
  margin-top: 34px;
  margin-bottom: 20px;

  transition: all 0.3s ease-in-out;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
